jQuery(document).ready(function($){
  $(".SlickCarousel").slick({
    rtl:false, // If RTL Make it true & .slick-slide{float:right;}
    autoplay:true, 
    autoplaySpeed:3000, //  Slide Delay
    speed:800, // Transition Speed
    slidesToShow:4, // Number Of Carousel
    slidesToScroll:1, // Slide To Move 
    pauseOnHover:false,
    appendArrows:$(".Container .Head .Arrows"), // Class For Arrows Buttons
    prevArrow:'<span class="Slick-Prev"></span>',
    nextArrow:'<span class="Slick-Next"></span>',
    easing:"linear",
    responsive:[
      {breakpoint:801,settings:{
        slidesToShow:3,
      }},
      {breakpoint:641,settings:{
        slidesToShow:3,
      }},
      {breakpoint:481,settings:{
        slidesToShow:1,
      }},
    ],
  })
})


jQuery(document).ready(function($){
  $(".SlickCarousel-1").slick({
    rtl:false, // If RTL Make it true & .slick-slide{float:right;}
    autoplay:true, 
    autoplaySpeed:5000, //  Slide Delay
    speed:800, // Transition Speed
    slidesToShow:4, // Number Of Carousel
    slidesToScroll:1, // Slide To Move 
    pauseOnHover:false,
    appendArrows:$(".Container .Head .Arrows"), // Class For Arrows Buttons
    prevArrow:'<span class="Slick-Prev"></span>',
    nextArrow:'<span class="Slick-Next"></span>',
    easing:"linear",
    responsive:[
      {breakpoint:801,settings:{
        slidesToShow:3,
      }},
      {breakpoint:641,settings:{
        slidesToShow:3,
      }},
      {breakpoint:481,settings:{
        slidesToShow:1,
      }},
    ],
  })
})
jQuery(document).ready(function($){
  $(".SlickCarousel-2").slick({
    rtl:false, // If RTL Make it true & .slick-slide{float:right;}
    autoplay:true, 
    autoplaySpeed:3000, //  Slide Delay
    speed:800, // Transition Speed
    slidesToShow:4, // Number Of Carousel
    slidesToScroll:1, // Slide To Move 
    pauseOnHover:false,
    appendArrows:$(".Container .Head .Arrows"), // Class For Arrows Buttons
    prevArrow:'<span class="Slick-Prev"></span>',
    nextArrow:'<span class="Slick-Next"></span>',
    easing:"linear",
    responsive:[
      {breakpoint:801,settings:{
        slidesToShow:3,
      }},
      {breakpoint:641,settings:{
        slidesToShow:3,
      }},
      {breakpoint:481,settings:{
        slidesToShow:1,
      }},
    ],
  })
})


/* Folders and Files Managemant system JS */
jQuery( document ).ready(function($) {
  const work_gallery = [
    {
      name: "Work for @Dr. Masood Pharma",
      descrp: "Customizable corporate stationery for their office space, to welcome new employees and utilise as brand promotion giveaways.",
      image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-21.webp",
      items: [
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-21.webp" },
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-22.webp" },
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-23.webp" }
      ]
    },
    {
      name: "Work for @Typespacestudios",
      descrp: "Customizable corporate stationery for their office space, to welcome new employees and utilise as brand promotion giveaways.",
      image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-6.jpg",
      items: [
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-1.jpg" },
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-2.jpg" },
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-3.jpg" },
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-4.jpg" },
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-5.jpg" },
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-6.jpg" }
      ]
    },
    {
      name: "Work for Lahore Grammar School",
      descrp: "Crafting awards that perfectly honor every unique event category.",
      image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-7.jpg",
      items: [
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-7.jpg" },
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-8.jpg" }
      ]
    },
    {
      name: "Work for Notion Pakistan",
      descrp: "Crafted Wooden frames with unique techniques showcasing cultural aspect",
      image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-9.jpg",
      items: [
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-9.jpg" },
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-10.jpg" }
      ]
    },
    {
      name: "Work for SSCCA",
      descrp: "Fridge Magnets as Giveaways",
      image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-11.jpg",
      items: [
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-11.jpg" }
      ]
    },
    {
      name: "Printables for sweet sujood",
      descrp: "Fridge Magnets as Giveaways",
      image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-12.jpg",
      items: [
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-12.jpg" },
        { name: "File-name", image: "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-13.jpg" }
      ]
    }

  ];

  if ($('#main-folders')?.length > 0) {
    let folders = '';
    work_gallery.forEach(function (item, index) {

      folders += '<div>\
        <a href="javascript:void(0);" class="folder-container" data-index="'+ index +'"> \
          <img alt="" src="'+ item.image +'">\
          <div class="grid-title">\
            <strong>'+ item.name +'</strong>\
            <p>'+ item.descrp +'</p>\
          </div>\
        </a>\
      </div>';

    });
    $('#main-folders').html(folders);
  }

  // Grid or list selection
  $('#btn-list').on('click', function() {
    $('#main-folders').addClass('flex-column');
    $('#btn-grid').removeClass('active')
    $(this).addClass('active')
  });
  $('#btn-grid').on('click', function() {
    $('#main-folders').removeClass('flex-column');
    $('#btn-list').removeClass('active')
    $(this).addClass('active')
  });
  $('#btn-list').on('click', function() {
    $('#main-files').addClass('flex-column');
    $('#btn-grid').removeClass('active')
    $(this).addClass('active')
  });
  $('#btn-grid').on('click', function() {
    $('#main-files').removeClass('flex-column');
    $('#btn-list').removeClass('active')
    $(this).addClass('active')
  });
  
  // Open folder and see files
  $('.folder-container').on('click', function() {
    $('#filesGroup').removeClass('d-none');
    $('#foldersGroup').addClass('d-none');
    const index = $(this).data('index');
    const gallery = work_gallery[index];

    $('.breadcrumb-item.folder').text(gallery.name);
    let files = '';
    gallery.items.forEach(function (item) {
      /*files += '<div class="d-inline-flex">\
            <a class="folder-container" href="'+ item.image +'">\
              <div class="folder-icon">\
                <img src="'+ item.image +'">\
              </div>\
            </a>\
          </div>';*/
      files += '<div>\
        <a href="'+ item.image +'"> \
          <img alt="" src="'+ item.image +'">\
        </a>\
      </div>';
    });
    $('#main-files').html(files);
    $('#main-files').magnificPopup({
      delegate: 'a',
      type: 'image',
      mainClass: 'mfp-with-zoom mfp-img-mobile',
      image: {
        verticalFit: true,
      },
      gallery: {
        enabled: true
      },
      zoom: {
        enabled: true,
        duration: 230,
        opener: function(element) {
          return element.find('img');
        }
      }
    });
    $("html, body").animate({ scrollTop: 100 }, "slow");
    
  });
  $('a#backToFolders').on('click', function() {
    $('#foldersGroup').removeClass('d-none');
    $('#filesGroup').addClass('d-none')
  });
});

$(document).ready(function () {

  const galleries = {
    "Dr. Masood Pharma": [
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-22.webp",
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-23.webp",
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/work-21.webp",
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/dr-masood-pharma-0.webp",
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/dr-masood-pharma-1.webp",
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/dr-masood-pharma-2.webp",
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/dr-masood-pharma-3.webp",
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/dr-masood-pharma-4.webp",
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/dr-masood-pharma-5.webp"
    ],
    "Type Space Studios": [
      "https://thecard.com.pk/cdn/shop/files/work-2.jpg",
      "https://thecard.com.pk/cdn/shop/files/work-4.jpg",
      "https://thecard.com.pk/cdn/shop/files/work-5.jpg",
      "https://thecard.com.pk/cdn/shop/files/work-6.jpg",
      "https://thecard.com.pk/cdn/shop/files/work-55.webp"
    ],
    "Lahore Grammar School": [
      "https://thecard.com.pk/cdn/shop/files/work-7.jpg",
      "https://thecard.com.pk/cdn/shop/files/work-8.jpg",
      "https://thecard.com.pk/cdn/shop/files/work-50.webp",
      "https://thecard.com.pk/cdn/shop/files/work-51.webp",
      "https://thecard.com.pk/cdn/shop/files/work-52.webp"
    ],
    "Notion Pakistan": [
      "https://thecard.com.pk/cdn/shop/files/work-9.jpg",
      "https://thecard.com.pk/cdn/shop/files/work-10.jpg"
    ],
    "SSCCA": [
      "https://thecard.com.pk/cdn/shop/files/work-11.jpg"
    ],
    "Cross Stitch": [
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/Cross-stitch-0_1.webp",
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/Cross-stitch-1_1.webp"
    ],
    "Sweet Sujood": [
      "https://thecard.com.pk/cdn/shop/files/work-12.jpg",
      "https://thecard.com.pk/cdn/shop/files/work-13.jpg"
    ],
    "Omar Hospital": [
      "https://thecard.com.pk/cdn/shop/files/work-53.webp",
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/Omer-hospital-1.webp",
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/Omer-hospital-2.webp",
      "https://cdn.shopify.com/s/files/1/0784/4747/7028/files/Omer-hospital-3.webp"
    ]
  };

  // Event delegation
  $(document).on("click", ".t4s-banner-inner", function () {

    // Find the clicked banner content block
    const $content = $(this).find(".t4s-banner-content");
    console.log($content);
    if (!$content.length) return;

    // Get the <p> inside it
    const $p = $content.find("p");
    if (!$p.length) return;

    const key = $p.text().trim();
    if (!galleries[key]) return;

    const items = galleries[key].map(function (img) {
      return { src: img, type: "image" };
    });

    Fancybox.show(items);

  });

});